import React from 'react';

// Sparkle SVG — 4-Punkt-Stern wie im Referenzbild
function Sparkle({ size = 12, style = {} }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={style}>
      <path d="M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z"
        fill="url(#sparkleGrad)" />
      <defs>
        <linearGradient id="sparkleGrad" x1="0" y1="0" x2="24" y2="24">
          <stop offset="0%" stopColor="#cc88ff" />
          <stop offset="100%" stopColor="#88ddff" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Logo({ size = 'md', fill = false }) {
  const sizes = {
    sm:  { text: 14, sub: 9,  box: 34, aiFont: 13 },
    md:  { text: 18, sub: 10, box: 42, aiFont: 16 },
    lg:  { text: 26, sub: 11, box: 56, aiFont: 20 },
    xl:  { text: 36, sub: 13, box: 72, aiFont: 26 },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 10,
      justifyContent: fill ? 'flex-start' : 'flex-start',
      width: fill ? '100%' : 'auto'
    }}>
      {/* AI Icon Box — gradient border + sparkles */}
      <div style={{ position: 'relative', flexShrink: 0 }}>
        {/* Outer glow */}
        <div style={{
          position: 'absolute', inset: -3,
          borderRadius: '38%',
          background: 'linear-gradient(135deg, #aa44ff, #00ccff)',
          opacity: 0.35,
          filter: 'blur(6px)',
          animation: 'glow-pulse 3s ease-in-out infinite'
        }} />

        {/* Box */}
        <div style={{
          width: s.box, height: s.box,
          borderRadius: '28%',
          background: 'linear-gradient(145deg, #1a0a2e 0%, #0a0a20 100%)',
          border: '1.5px solid transparent',
          backgroundClip: 'padding-box',
          position: 'relative',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 0 0 1.5px rgba(150,80,255,0.6), 0 0 0 3px rgba(0,200,255,0.25)',
          zIndex: 1,
          overflow: 'visible'
        }}>
          {/* AI Text */}
          <span style={{
            fontFamily: 'Orbitron', fontWeight: 900,
            fontSize: s.aiFont, letterSpacing: '0.05em',
            background: 'linear-gradient(135deg, #00ffff 0%, #aa55ff 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            lineHeight: 1
          }}>AI</span>

          {/* Sparkle oben links */}
          <Sparkle size={s.box * 0.3}
            style={{ position: 'absolute', top: -s.box * 0.18, left: -s.box * 0.08, animation: 'float 2.5s ease-in-out infinite' }}
          />
          {/* Sparkle oben rechts — größer */}
          <Sparkle size={s.box * 0.45}
            style={{ position: 'absolute', top: -s.box * 0.28, right: -s.box * 0.18, animation: 'float 3.2s ease-in-out infinite 0.4s' }}
          />
          {/* Sparkle unten links — klein */}
          <Sparkle size={s.box * 0.22}
            style={{ position: 'absolute', bottom: -s.box * 0.12, left: s.box * 0.1, animation: 'float 2.8s ease-in-out infinite 0.8s' }}
          />
        </div>
      </div>

      {/* Wordmark */}
      <div>
        <div style={{
          fontFamily: 'Orbitron', fontWeight: 800,
          fontSize: s.text, lineHeight: 1.1,
          letterSpacing: '-0.01em', whiteSpace: 'nowrap'
        }}>
          <span style={{ color: 'var(--text)' }}>look</span>
          <span style={{ color: '#3B8BD4' }}>4</span>
          <span style={{ color: 'var(--text)' }}>more</span>
        </div>
        <div style={{
          fontSize: s.sub, color: 'var(--muted)',
          fontFamily: 'Outfit', letterSpacing: '0.1em',
          marginTop: 2
        }}>
          Social Media AI
        </div>
      </div>
    </div>
  );
}
